import styled from "styled-components/macro"

export const ScrollBody = styled.div`
  overflow-y: auto;
  height: calc(100% - 41px);
  padding: 20px;
`
